module.exports = __webpack_public_path__ + "static/wired-for-story-8bfbe169ea26b59fb533f2d0c3c16925.jpg";